import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/creator-guide/page.tsx")